import SatelliteCreatePage from "./SatelliteCreatePage";

export default SatelliteCreatePage;